import { Link } from 'react-router'
import { Badge } from '@klear/ui/components/badge'
import { ROUTE_ORDERS, ROUTE_TRADER, parseOrderIdFromDisplay } from '@klear/constants'

interface OrderContextMetaProps {
  idDisplay: string
  orderIdDisplay?: string
  customerName?: string
  traderId?: number
  traderName?: string
}

export default function OrderContextMeta({
  idDisplay,
  orderIdDisplay,
  customerName,
  traderId,
  traderName
}: OrderContextMetaProps) {
  const orderLinkable = orderIdDisplay != null && parseOrderIdFromDisplay(orderIdDisplay) != null

  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <Badge variant="outline">{idDisplay}</Badge>
      {orderLinkable ? (
        <Link to={`/${ROUTE_ORDERS}/${orderIdDisplay}`} className="underline">
          {orderIdDisplay}
        </Link>
      ) : null}
      {customerName ? <span>{customerName}</span> : null}
      {traderId != null && traderId > 0 ? (
        <Link to={`/${ROUTE_TRADER}/${traderId}`} className="underline">
          {traderName ?? `Trader #${traderId}`}
        </Link>
      ) : null}
    </div>
  )
}
